import { Font } from "../../../../util/config-fonts";

function HorizontalCategory({ url, description, callBack }) {
  return (
    <div
      style={{
        marginLeft: 10,
        marginRight: 10,
        marginTop: 10,
        cursor: "pointer",
      }}
      onClick={() => {
        callBack();
      }}
    >
      <img
        src={url}
        style={{ height: 80, width: 80, borderRadius: 100 }}
      />
      <div
        style={{
          margin: 0,
          lineClamp: 2,
          WebkitLineClamp: 2,
          textAlign: "center",
          fontSize: Font.Description,
        }}
      >
        {description}
      </div>
    </div>
  );
}
export default HorizontalCategory;
